module.exports = __webpack_public_path__ + "img/pr-2.6e4e463e.png";